import { render, staticRenderFns } from "./TableAssignedPetitions.vue?vue&type=template&id=0e079ad8"
import script from "./TableAssignedPetitions.vue?vue&type=script&lang=js"
export * from "./TableAssignedPetitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports